import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  CPP_AmenitiesAndFacilitiesSkeletonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '24px 32px',
  },
  fieldWrapper: {
    display: 'flex',
    gap: '32px',
    margin: '20px 0px',
  },
}));
